import {NgModule} from '@angular/core';
import {AddPaymentGroupModalComponent} from './add-payment-group-modal/add-payment-group-modal.component';
import {AddPaymentMethodComponent} from './add-payment-method/add-payment-method.component';
import {AssignPaymentMethodComponent} from './assign-payment-method/assign-payment-method.component';
import {EditPaymentMethodComponent} from './edit-payment-method/edit-payment-method.component';
import {SharedComponentsModule} from '../shared-components.module';
import { PaymentMethodListComponent } from './payment-method-list/payment-method-list.component';
import { InvoiceHistoryListComponent } from './invoice-history-list/invoice-history-list.component';
import { SendInvoiceModalComponent } from './dialogs/send-invoice-modal/send-invoice-modal.component';
import {NgbModal, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { OneTimePaymentModalComponent } from './one-time-payment-modal/one-time-payment-modal.component';
import { AddPaymentMethodModalComponent } from './add-payment-method-modal/add-payment-method-modal.component';
import { CurrencyPipe } from '@angular/common';
import { GuestPaymentModalComponent } from './guest-payment-modal/guest-payment-modal.component';
import { OneTimePaymentDraftComponent } from './one-time-payment-draft/one-time-payment-draft.component';

@NgModule({
    declarations: [
        AddPaymentGroupModalComponent,
        AddPaymentMethodComponent,
        AssignPaymentMethodComponent,
        EditPaymentMethodComponent,
        PaymentMethodListComponent,
        InvoiceHistoryListComponent,
        SendInvoiceModalComponent,
        OneTimePaymentModalComponent,
        AddPaymentMethodModalComponent,
        GuestPaymentModalComponent,
        OneTimePaymentDraftComponent,
    ],
    imports: [
        SharedComponentsModule,
        NgbModule
    ],
    exports: [
        PaymentMethodListComponent,
        InvoiceHistoryListComponent,
    ]
})
export class PaymentModule {
}
